export enum CellEdCommonQuestionKeys {
  EDUCATION_LEVEL = 'educationLevel',
  EMPLOYER = 'employer',
  EMPLOYMENT_CERTIFICATE = 'employmentCertificate',
  PAY_STUB = 'paystub',
  PROOF_EMPLOYMENT = 'proofEmployment',
  SUPERVISOR_NAME = 'supervisorName',
  SUPERVISOR_PHONE = 'supervisorPhone',
}
